var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+=''+
((__t=( t('Common', 'surveyParticipation.thankYou') ))==null?'':_.escape(__t))+
'\n';
}
return __p;
};
